import { Pencil1Icon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'
import { KVCameraView } from 'types'

const StyledPencilIcon = styled(Pencil1Icon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

// Replace the any type with a proper interface
interface CameraViewData {
  id: string
  name: string
  notes: string
  cameraPosition: string
  cameraRotation: string
}

export const EditCameraViewButton: FC<{
  cameraView: KVCameraView
}> = ({ cameraView }) => {
  const { setPopupMenuStartPosition, setSelectedMarkup, cameraViews } =
    useKestrel()

  // Get the current camera view data from the cameraViews array
  const currentCameraView = useMemo(() => {
    const found = cameraViews?.find((cv) => cv.id === cameraView.id)
    return found || cameraView
  }, [cameraViews, cameraView])

  const handleEditClick = (e: React.MouseEvent) => {
    e.stopPropagation()

    // Ensure we're setting a proper KVCameraView instance
    let cameraViewToSet: KVCameraView

    if (currentCameraView instanceof KVCameraView) {
      cameraViewToSet = currentCameraView
    } else {
      // Create a new KVCameraView instance from the data
      const data = currentCameraView as CameraViewData
      cameraViewToSet = new KVCameraView(data.id)
      cameraViewToSet.name = data.name
      cameraViewToSet.notes = data.notes
      cameraViewToSet.cameraPosition = data.cameraPosition
      cameraViewToSet.cameraRotation = data.cameraRotation
    }

    if (setPopupMenuStartPosition) {
      setPopupMenuStartPosition(new Vector2(10, e.clientY - 40))
    }
    setSelectedMarkup(cameraViewToSet)
  }

  return (
    <TooltipWrapper side={'right'} offset={5} label={'Edit Camera View'}>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={handleEditClick}
        data-action-button='true'>
        <StyledPencilIcon width={20} height={20} />
      </div>
    </TooltipWrapper>
  )
}
